var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rgbw-control-editor',{attrs:{"objData":_vm.objData,"realtime":""}})}
var staticRenderFns = []

export { render, staticRenderFns }